import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const meetingTutorialStorageKey = 'geoescala:onboarding-meeting-desktop-tutorial';

const MeetingDesktopTutorial = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const alreadySeen =
      window.localStorage.getItem(meetingTutorialStorageKey) === 'dismissed';

    if (isDesktop && !alreadySeen) {
      const timeout = window.setTimeout(() => setIsVisible(true), 900);
      return () => window.clearTimeout(timeout);
    }
  }, []);

  const dismissTutorial = () => {
    setIsVisible(false);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(meetingTutorialStorageKey, 'dismissed');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="pointer-events-auto absolute left-4 top-4 z-30 hidden w-[min(360px,calc(100%-2rem))] rounded-lg border border-border bg-card/95 p-4 text-card-foreground shadow-lg backdrop-blur-md md:block">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          <h2 className="text-sm font-semibold">
            {t('onboarding_interviews.meeting.desktop_tutorial_title')}
          </h2>
          <p className="mt-1 text-xs text-muted-foreground">
            {t('onboarding_interviews.meeting.desktop_tutorial_description')}
          </p>
        </div>
        <button
          type="button"
          className="rounded-md px-2 py-1 text-xs font-medium text-muted-foreground hover:bg-muted hover:text-foreground"
          onClick={dismissTutorial}
          aria-label={t('common.close')}
          title={t('common.close')}
        >
          ×
        </button>
      </div>
      <div className="space-y-2 text-xs text-muted-foreground">
        <p>{t('onboarding_interviews.meeting.desktop_tutorial_controls')}</p>
        <p>{t('onboarding_interviews.meeting.desktop_tutorial_pin')}</p>
        <p>{t('onboarding_interviews.meeting.desktop_tutorial_preview')}</p>
      </div>
      <Button
        type="button"
        size="sm"
        className="mt-4 h-8 w-full"
        onClick={dismissTutorial}
      >
        {t('onboarding_interviews.meeting.desktop_tutorial_done')}
      </Button>
    </div>
  );
};

export default MeetingDesktopTutorial;
